<script>
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            sourceCourses: String,
            sourceSports: String,
            sourceMunicipality: String
        },
        data() {
            return {
                form: new Form({
                    municipality: '',
                    sport: '',
                    age: ''
                })
            }
        },
        computed: {
            dropdownAgeLabel() {
                return _.isNumber(this.form.age)
            }
        },
        mounted() {
            this.initSelect();
        },
        methods: {
            onSelectAge(age) {
                this.$set(this.form, 'age', age)
            },
            isSelected(n) {
                return this.form.age === n
            },
            initSelect() {
                let vm = this
                $(this.$refs.sports).select2({
                    placeholder: 'Sport o attività',
                    width: '100%',
                    ajax: {
                        url: vm.sourceSports,
                        processResults({sports}) {
                            let results = []
                            sports.forEach(i => {
                                results.push({
                                    id: i.id,
                                    text: i.name
                                })
                            })

                            return {
                                results: results
                            }
                        }
                    }
                });

                $(this.$refs.municipality).select2({
                    placeholder: 'Cerca per città',
                    width: '100%',
                    ajax: {
                        url: vm.sourceMunicipality,
                        processResults({municipalities}) {
                            let results = []
                            municipalities.forEach(i => {
                                results.push({
                                    id: i.name,
                                    text: i.name
                                })
                            })

                            return {
                                results: results
                            }
                        }
                    }
                });

                $(this.$refs.municipality).on('change', function(e) {
                    vm.$set(vm.form, 'municipality', $(this).val())
                })

                $(this.$refs.sports).on('change', function(e) {
                    vm.$set(vm.form, 'sport', $(this).val())
                })
            },
            onSubmit() {
                this.form
                    .get(this.sourceCourses, {}, true)
                    .then(({courses}) => {
                        this.$bus.$emit('update', {
                            courses,
                            params: this.form.data()
                        })
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/GiftCourseSearchForm.vue